import React from 'react'
import {
    Toaster as ReactHotToaster,
    ToastBar as ReactHotToastBar,
} from 'react-hot-toast'
import {useTypedTranslation} from 'i18n'

const Toaster = () => {
    const {t} = useTypedTranslation()
    return (
        <ReactHotToaster>
            {(toast) => {
                const {message} = toast
                const translatedMessage = message
                    ? t(message.toString())
                    : message
                return (
                    <ReactHotToastBar
                        toast={{
                            ...toast,
                            message: translatedMessage,
                        }}
                    />
                )
            }}
        </ReactHotToaster>
    )
}

export default Toaster
